import { Injectable } from '@angular/core';
import { AccessTokenPayload } from '../model/access-token-payload';
import jwtDecode from 'jwt-decode';

/** Service to decode JWT access tokens and expose common claims. */

/** Load and decode access_token from localStorage if present. */
/** Decode token; on failure clear cached payload. */
/** Get decoded token payload (or null). */
/** Get user id (userId or sub). */
/** Get username (or null). */
/** Clear cached decoded payload (e.g. on sign out). */
@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {

  private decodedToken: AccessTokenPayload | null = null;

  initializeToken(): void {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      this.decodeAndStoreToken(accessToken);
    }
  }

  decodeAndStoreToken(token: string): void {
    try {
      this.decodedToken = jwtDecode<AccessTokenPayload>(token);
    } catch (err) {
      this.decodedToken = null;
    }
  }

  getDecodedToken(): AccessTokenPayload | null {
    return this.decodedToken;
  }

  getUserId(): string | null {
    return this.decodedToken?.userId ?? this.decodedToken?.sub ?? null;
  }

  getUsername(): string | null {
    return this.decodedToken?.username ?? null;
  }

  clearToken(): void {
    this.decodedToken = null;
  }
}
